import React, { useContext, useState, useEffect } from 'react';
import FlyUpModal from '../FlyUpModal';
import './QuizModal.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { AppContext } from "../../../../AppContext.jsx";
import ModalOverlay from '../ModalOverlay';
import { getQuizQuestionList, getQuizResult, getAllSceneInfoDictAsync, getactivateProductModalKey, getStoreId } from '../../../../utils/StoreConfigManager.js';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import Variables from '../../../../../../variables/Variables';
import { getProductInfoAsyncObsessAPI, getLocalizedProductInfoAsyncObsessAPI } from '../product/extended-product-modal/util/ProductModalData';
import { AddToCartContext } from '../../add-to-cart/AddToCartContext';
import { QuizAnswerClicked, QuizExitClicked, QuizStartClicked, QuizViewMoreClicked } from '../../../../utils/Analytics';
import I18NextContext from '../../i18next-context/I18NextContext';
import { getLocaleForAPI } from '../../../../../i18n/locales/utils';


import { constructUrl } from '../../../../utils/UrlConstructor';
const isMobile = isMobileDevice();
import { withTranslation } from 'react-i18next';

const WELCOME_LOGO_URL = 'https://cdn.obsess-vr.com/ferragamo/logo-header-inverted.svg';
const cartIcon = 'https://cdn.obsess-vr.com/ferragamo/Bag.svg';
const uiInitialState = {
    showWelcome: true,
    showQuiz: false,
    showQuizResult: false,
    showAnimation: false
}
const { apiUrl } = Variables;

const QuizModal = ({onModalHidden, t}) => {
    const questionList = getQuizQuestionList(t);
    const { setQuizVisibility,setQuizSceneProductSku } = useContext(AppContext);
    const { currentLanguage } = useContext(I18NextContext);
    const { history, pushHistoryWithReset } = useContext(ThreeJSWorldContext);
    const [currentindex, setCurrentIndex] = useState(0);
    const [answerList, setAnswerList] = useState([]);
    const [uiState, setUiState] = useState(uiInitialState);
    const [selectedAnswer, setSelectedAnswer] = useState(0);
    const [quizResult, setQuizResult] = useState(null);
    const [sceneIdNameDict, setSceneIdNameDict] = useState({});
    const [questionData, setQuestionData] = useState({});
    const [productsInfo, setProductsInfo] = useState([]);

    const HARDCODED_IMAGE_URL_FOR_DEMO = {
        0: 'https://cdn.obsess-vr.com/ferragamo/image_7.png',
        1: 'https://cdn.obsess-vr.com/ferragamo/image_6.png',
        2: 'https://cdn.obsess-vr.com/ferragamo/image_8.jpg',
        3: 'https://cdn.obsess-vr.com/ferragamo/image_9.jpg',
        4: 'https://cdn.obsess-vr.com/ferragamo/image_8.png',
        5: 'https://cdn.obsess-vr.com/ferragamo/image_6.png',
    }

    useEffect(() => {
        getAllSceneInfoDictAsync()
            .then(sceneInfoDict => {
                const idNameDict = {};
                for (const [id, info] of Object.entries(sceneInfoDict)) {
                    idNameDict[id] = info['name'];
                }
                setSceneIdNameDict(idNameDict)
            })
            .catch(error => console.error(error));
            
    }, []);

    useEffect(() => {
        if (uiState.showQuizResult) {
            //fetchProductInfo()
        }
    }, [uiState.showQuizResult])

    useEffect(() => {
        const currentQuestion = questionList[currentindex];
        setQuestionData(currentQuestion)
    }, [currentindex])

    useEffect(() => {
        submitAnswer()
    }, [selectedAnswer])

    const startQuiz = () => {
        QuizStartClicked();
        setUiState(prevState => ({
            ...prevState,
            showWelcome: false,
            showQuiz: true
        }));
    }

    const OnAnswerOptionClicked = (answerIndex) => {
        setSelectedAnswer(answerIndex + 1);
    }

    const showResult = () => {
        setUiState(prevState => ({
            ...prevState,
            showAnimation:false,
            showQuizResult: true
        }));
    }
    async function filter(arr, callback) {
        const fail = Symbol()
        return (await Promise.all(arr.map(async item => (await callback(item)) ? item : fail))).filter(i=>i!==fail)
    }

    const submitAnswer = async () => {
        if (!selectedAnswer) return;

        let prevAnswersList = answerList;
        prevAnswersList.push(selectedAnswer);
        setAnswerList(prevAnswersList);
        QuizAnswerClicked(selectedAnswer);
        if (currentindex == questionList.length - 1) {
            setUiState(prevState => ({
                ...prevState,
                showQuiz: false,
            }));
        
            const products = getQuizResult("" + prevAnswersList.join(''))
            const locale = getLocaleForAPI(currentLanguage)
            

            const results = await filter(products.products, async item => {
                let result = false;
                const test = await getLocalizedProductInfoAsyncObsessAPI(item.sku, locale, apiUrl, getStoreId()).then((x)=> {
                    result = true;
                }).catch((err)=>{
                    result = false;
                });
                return result;
            });

            const quizResult = {"products": results};
            setQuizResult(quizResult);
             fetchProductInfo(quizResult)

            
            setUiState(prevState => ({
                ...prevState,
                showAnimation: true
            }));
            setTimeout(showResult, 3000);
        } else {
            setSelectedAnswer(0);
            setCurrentIndex(currentindex + 1);
        }
    }

    const goToScene = (sceneId, productSku = null, text = null) => {
        setQuizVisibility(false)
        if (productSku) {
            sessionStorage.setItem(getactivateProductModalKey(), productSku)
        }
        const linkedSceneName = sceneIdNameDict[sceneId];
        if (productSku) {
            sessionStorage.setItem(getactivateProductModalKey(), productSku)
        }else{
        }
        QuizViewMoreClicked(productSku);
        let targetPath = `/${currentLanguage}/${linkedSceneName}`;
        console.log(history.location.pathname,'<<<<pathname',targetPath,'<<<targetPathName');
        if (history.location.pathname !== targetPath) {
            pushHistoryWithReset(targetPath);
        }else{
            setQuizSceneProductSku(productSku);
        }
    }

    const renderWelcomeContent = () => {
        return (
            <div className='quiz-inner-wrapper' id="firstScreen">
                <div className='quiz-top-text'>
                    <img src={WELCOME_LOGO_URL} height="35" />
                </div>
                <div className='quiz-main-text'>
                    {t('quizTitle')}
                </div>
                <div className='quiz-button-main' onClick={startQuiz}>
                    {t('quizStartHeader')}
                </div>
            </div>
        )
    }

    const renderAnswers = (questionData) => {
        return questionData.answers.map((item, index) => {
            return (
                <div
                    key={`answer-${index}`}
                    className={`quiz-option ${(selectedAnswer === index + 1) ? 'active' : ''}`}
                    onClick={() => OnAnswerOptionClicked(index)}
                >
                    {item}
                </div>
            )
        })
    }

    const renderQuestionContent = () => {
        return (
            <div className='quiz-inner-wrapper' id="secondScreen">
                <div className='quiz-top-text'>{`${t('quizQuestionHeader')} ${currentindex + 1} of ${questionList.length}`}</div>
                <div className='quiz-question'>{questionData.question}</div>
                <div className='quiz-ans-options'>
                    {renderAnswers(questionData)}
                </div>
                {/* <div
                    className={`quiz-button-main ${selectedAnswer ? '' : 'disabled'}`}
                    onClick={submitAnswer}
                >
                    NEXT
                </div> */}
            </div>
        )
    }

    const renderAnimation = () => {
        return (
            <div className='quiz-inner-wrapper' id="watingScreen">
                <div className='quiz-loading-text'>{t('quizAnswerFinish')}</div>
            </div>
        )
    }

    const fetchProductInfo = async (productsList) => {
         let products = []
         const imageResult = productsList.products.map(async (item, index) => {
             if (item.sku) {
                 const productDetail = await getProductInfoAsyncObsessAPI(item.sku, apiUrl, getStoreId());
                 if (productDetail) {
                    products[item.sku] = productDetail
                    return productDetail;
                 } else {
                     return true;
                 }
             } else {
                 return true;
             }
        });
         
        Promise.all(imageResult).then((results) => {
            setProductsInfo(products)
        })
    }

    const renderCarousel = () => {
        return quizResult.products.map((item, index) => {
            let imageUrl = HARDCODED_IMAGE_URL_FOR_DEMO[index];

            return (
                <div className="carousel-item" key={`carousel-key${index}`}>
                    <div className='carousel-item-image'>
                        <img src={imageUrl} alt="product-image" className='carousel-image' />
                    </div>
                    <div className='customBtn add-to-cart' onClick={() => item.sceneId ? goToScene(item.sceneId, item.sku, productData.name) : false}>
                        {t('quizViewDetail')}
                    </div>
                </div>
            )
        })
    }

    const renderQuizresult = () => {
        const totalProduct = quizResult.products.length;
        const carouselClass = {
            '1': 'single-product',
            '2': 'double-product',
            '3': 'three-product'
        }
        const carouselClassName = carouselClass[totalProduct] ? carouselClass[totalProduct] : '';
        return (
            <div className='quiz-inner-wrapper last-screen' id="lastScreen">
                {/* <div className='quiz-div'>
                </div> */}
                <div className="quiz-subheading">
                    {t('quizLanding')}
                </div>
                <div className={`quiz-carousel ${carouselClassName}`}>
                <div id="container">
                    {renderCarousel()}
                </div>
                </div>
            </div>
        )
    }

    const renderModalContent = () => {
        return (
            <div className='quiz-modal-content'>
                {uiState.showWelcome && renderWelcomeContent()}
                {uiState.showQuiz && renderQuestionContent()}
                {uiState.showAnimation && renderAnimation()}
                {uiState.showQuizResult && renderQuizresult()}                     
            </div>
        )
    }

        return (
            //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
            <FlyUpModal extraClassName={`quiz-modal-container`} isOpaque
                textPopup hideCloseIcon isImageLoaded onModalHidden={onModalHidden} QuizExitClicked={QuizExitClicked}>
                <ModalOverlay />
                {renderModalContent()}
            </FlyUpModal>           
        );
}

export default withTranslation()(QuizModal);


